import { SmsListFilter } from './SmsListFilter'

const SmsListToolbar = () => {
  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <SmsListFilter />
    </div>
  )
}

export {SmsListToolbar}
